attribute vec3 destination;
attribute vec3 color;
attribute float aSpeed;

uniform float uProgress;
uniform float uTime;

varying vec3 vColor;

void main() {
  vColor = color;

  float localProgress = clamp(uProgress * aSpeed, 0.0, 1.0);

  vec3 direction = destination - position;
  
  vec3 currentPos = position + (direction * localProgress * (2.5 + position.x * 0.1));

  float gravity = pow(localProgress, 2.0) * 80.0;
  currentPos.y -= gravity;

  currentPos.x += sin(uTime * 2.0 + position.y) * localProgress * 0.5;

  vec4 mvPosition = modelViewMatrix * vec4(currentPos, 1.0);
  
  gl_PointSize = 7.5 * (1.0 - localProgress); 
  gl_Position = projectionMatrix * mvPosition;
}